export const NoSelect = {
  '-webkit-touch-callout': 'none' /* iOS Safari */,
  '-webkit-user-select': 'none' /* Safari */,
  '-moz-user-select': 'none' /* Firefox */,
  '-ms-user-select': 'none' /* Internet Explorer/Edge */,
  'user-select': 'none',
};
